<template>
  <div id="app">
    <v-app>
      <v-content>
        <v-fade-transition mode="out-in">
          <router-view/>
        </v-fade-transition>
      </v-content>
      <v-app-notifications />
    </v-app>
  </div>
</template>

<script>
import VAppNotifications from "./components/AppNotifications";

export default {
  components: {
    VAppNotifications
  }
};
</script>
